import "./intro.scss";
import Typewriter from 'typewriter-effect/dist/core';


export default function Intro() {
  var app = document.getElementById('typewriter');

  var typewriter = new Typewriter(app, {
    loop: true,
    delay: 75,
    autoStart: true

  });

  typewriter
  
  .pauseFor(200)
  .typeString('Ethical Hacker')
  .deleteChars(14)
  .typeString('Bug Bounty Hunter')
  .deleteChars(17)
  .typeString('Web Developer')
  .pauseFor(1000)
  .start();

  return (
    <div className="intro" id="intro">
      <div className="left">
        <div className="imgContainer">
          <img src="assets/me1.png" alt="" />
        </div>
      </div>
      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I'm</h2>
          <h1>Uppala Narasimha</h1>
          <h3>
          Expert In <span id="typewriter"></span>
          </h3>
        </div>
        <a href="#portfolio">
          <img src="assets/down.png" alt="" />
        </a>
      </div>
    </div>
  );
}
